import { anyOf, arrayOf, enumOf, objectOf, recordOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, string, number } from "@altostra/type-validations/lib/primitives";

import sharedConstants from "@lib/shared_constants";

const { CUSTOM_ATTRIBUTE, CUSTOM_EVENT } = sharedConstants.CONVERSATION_TOOL_DEFINITION;

export const isWorkflowAttributeAllowedValue = objectOf({
  value: anyOf(string, number, boolean),
  description: string,
});

export const isWorkflowAttributeDefinitionResultObject = objectOf({
  id: string,
  type: enumOf("workflow_attribute"),
  name: string,
  description: string,
  data_type: enumOf(...sharedConstants.CONVERSATION_TOOL_DEFINITION.DATA_TYPES),
  allowed_values: arrayOf(isWorkflowAttributeAllowedValue),
  created_at: string,
  updated_at: string,
  created_by_email: string,
});

export const isWebhookVariable = objectOf({
  name: string,
  data_type: enumOf(...sharedConstants.CONVERSATION_TOOL_DEFINITION.DATA_TYPES),
  source: enumOf(...sharedConstants.CONVERSATION_TOOL_DEFINITION.WEBHOOK.VARIABLE_SOURCES),
  source_id: anyOf(string, nullOrUndefined),
  description: anyOf(string, nullOrUndefined),
  required: boolean,
});

export const isWebhookResponseField = objectOf({
  name: string,
  path: string,
  description: string,
});

export const isWebhookDefinitionResultObject = objectOf({
  id: string,
  type: enumOf("webhook"),
  name: string,
  description: string,
  request_method: enumOf(...sharedConstants.CONVERSATION_TOOL_DEFINITION.WEBHOOK.REQUEST_METHODS),
  url: string,
  body: anyOf(string, nullOrUndefined),
  headers: recordOf(string),
  credential_name: anyOf(string, nullOrUndefined),
  variables: arrayOf(isWebhookVariable),
  response_fields: arrayOf(isWebhookResponseField),
  created_at: string,
  updated_at: string,
  created_by_email: string,
});

export const isCustomAttributeDefinitionResultObject = objectOf({
  id: string,
  type: enumOf("custom_attribute"),
  name: string,
  description: string,
  attribute_name: string,
  source: enumOf(...CUSTOM_ATTRIBUTE.SOURCES),
  source_id: anyOf(string, nullOrUndefined),
  created_at: string,
  updated_at: string,
  created_by_email: string,
});

export const isCustomEventProperty = objectOf({
  name: string,
  source: enumOf(...CUSTOM_EVENT.PROPERTY_SOURCES),
  source_id: anyOf(string, nullOrUndefined),
  description: anyOf(string, nullOrUndefined),
  required: boolean,
});

export const isCustomEventDefinitionResultObject = objectOf({
  id: string,
  type: enumOf("custom_event"),
  name: string,
  description: string,
  event_name: string,
  properties: arrayOf(isCustomEventProperty),
  created_at: string,
  updated_at: string,
  created_by_email: string,
});

export const isKnowledgeSourceSearchDefinitionResultObject = objectOf({
  id: string,
  type: enumOf("knowledge_source_search"),
  name: string,
  description: string,
  knowledge_source_definition_id: string,
  excluded_fields: arrayOf(string),
  created_at: string,
  updated_at: string,
  created_by_email: string,
});

export const isConversationalToolDefinitionResultObject = anyOf(
  isWorkflowAttributeDefinitionResultObject,
  isWebhookDefinitionResultObject,
  isCustomAttributeDefinitionResultObject,
  isCustomEventDefinitionResultObject,
  isKnowledgeSourceSearchDefinitionResultObject
);

export const isConversationalToolDefinitionIdResult = objectOf({
  result: isConversationalToolDefinitionResultObject,
});
